<template>
  <div id="AccountSummaryMobile">
    <div class="content">
      <b-container>
        <div class="title">Account Summary</div>
      </b-container>
      <b-container class="summary-container">
        <div class="user" v-if="purl">
          <div class="item">
            <div class="small">account name</div>
            <div class="big">{{ purl.firstName }} {{ purl.lastName }}</div>
          </div>
          <div class="item">
            <div class="small">account number</div>
            <div class="big">{{ purl.accountId }}</div>
          </div>
        </div>
        <template v-if="purl.accounts">
          <div
            class="info"
            v-for="(account, index) in purl.accounts"
            :key="'account' + index"
          >
            <div class="item">
              <div class="header">section</div>
              <div class="value">{{ account.section }}</div>
            </div>
            <div class="item">
              <div class="header">row</div>
              <div class="value">{{ account.row }}</div>
            </div>
            <div class="item">
              <div class="header">seats</div>
              <div class="value">
                {{ account.seatFrom }} - {{ account.seatTo }}
              </div>
            </div>
            <div class="item" v-if="account.planType == 'FS'">
              <div class="header">term</div>
              <div class="value">full season</div>
            </div>
            <div class="item" v-else>
              <div class="header">term</div>
              <div class="value">half season</div>
            </div>
            <div class="item">
              <div class="header">price per seat</div>
              <div class="value">{{ account.pricePerSeat }}</div>
            </div>
            <div class="item">
              <div class="header">total due</div>
              <div class="value">{{ account.totalPrice }}</div>
            </div>
          </div>
          <div class="totals">
            <div class="item">
              <div class="header">account credit:</div>
              <div class="value">
                $<span>{{ accountCredit(purl.accounts[0].credit) }}.00</span>
              </div>
            </div>
            <div class="item">
              <div class="header">total package cost:</div>
              <div class="value">
                $<span>{{ totalCalc(purl.accounts) }}.00</span>
              </div>
            </div>
          </div>
          <div class="bottom">
            <a
              class="renew"
              href="https://am.ticketmaster.com/pistons/"
              target="_blank"
              @click="store.dispatch('purl/purlTracking', 'Renew Now')"
            >
              renew now</a
            >
            <a
              href="https://www.nba.com/pistons/terms"
              target="_blank"
              class="terms"
              @click="store.dispatch('purl/purlTracking', 'Terms & Conditions')"
              >Terms & Conditions</a
            >
          </div>
        </template>
      </b-container>
    </div>
    <img
      class="player"
      src="@/assets/images/account/account-summary-player.png"
    />
  </div>
</template>

<script>
import { reactive, toRefs, computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "AccountSummaryMobile",
  setup() {
    const store = useStore();

    // State
    const state = reactive({
      purl: computed(() => store.getters["purl/getAccount"]),
    });

    return { ...toRefs(state) };
  },
  // mounted() {
  //   setTimeout(() => {
  //     console.log("accounts", this.$store.state.purl.info.accounts);
  //     console.log("purl", this.purl);
  //   }, 1000);
  // },
  methods: {
    totalCalc(accounts) {
      let totalValue = 0;
      let credit = parseInt(accounts[0].credit.replace(/[$,]/g, ""));
      accounts.forEach((account) => {
        totalValue += parseInt(account.totalPrice.replace(/[$,]/g, ""));
      });

      let newTotal = totalValue - credit;
      if (newTotal < 0) {
        return 0;
      } else {
        return newTotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }

      // return totalValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    accountCredit(credit) {
      let newCredit = parseInt(credit.replace(/[$,]/g, ""));
      return newCredit.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>

<style lang="scss" scoped>
#AccountSummaryMobile {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 13px;
  .content {
    background: url("~@/assets/images/seating/seating-map-bg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    .container {
      display: flex;
      flex-direction: column;
      &.summary-container {
        @media (max-width: 600px) {
          max-width: 100vw;
          padding: 0;
        }
      }
    }
    .title {
      font-family: Birdrockers;
      font-weight: normal;
      font-size: 42px;
      line-height: 42px;
      letter-spacing: normal;
      color: #ffffff;
      margin-top: 44.72px;
      margin-bottom: 35px;
    }
    .user {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      background: #000000;
      padding: 15px 20px 15px 19px;
      margin-bottom: 20px;
      .item {
        display: flex;
        flex-direction: column;
        min-width: 148px;
        &:first-child {
          margin-right: 50px;
        }
        .small {
          font-family: Abolition;
          font-weight: normal;
          font-size: 18px;
          line-height: 21px;
          letter-spacing: normal;
          color: #ffffff;
          text-transform: uppercase;
        }
        .big {
          font-family: Abolition;
          font-weight: normal;
          font-size: 30px;
          line-height: 30px;
          letter-spacing: normal;
          color: #ffffff;
          text-transform: uppercase;
        }
      }
    }
    .info {
      display: flex;
      flex-direction: column;
      padding: 20px;
      width: 100%;
      &:nth-child(odd) {
        background: #000000;
      }
      .item {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        padding: 10px 0;
        border-bottom: 1px solid #3d3d3d;
        &:last-child {
          border-bottom: none;
        }
        .header {
          font-family: Abolition;
          font-weight: normal;
          font-size: 20px;
          line-height: 24px;
          letter-spacing: normal;
          color: #ffffff;
          text-transform: uppercase;
        }
        .value {
          font-family: DINPro;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: normal;
          color: #ffffff;
          text-transform: uppercase;
        }
      }
    }
    .totals {
      display: flex;
      flex-direction: column;
      padding: 25px 20px;
      .item {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        width: 100%;
        padding: 10px 0;
        &:last-child {
          border-bottom: none;
        }
        .header {
          font-family: Abolition;
          font-weight: normal;
          font-size: 20px;
          line-height: 24px;
          letter-spacing: normal;
          color: #ffffff;
          text-transform: uppercase;
        }
        .value {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          font-family: DINPro;
          font-weight: 500;
          font-size: 16px;
          line-height: 24px;
          letter-spacing: normal;
          color: #ffffff;
          text-transform: uppercase;
          min-width: 94px;
          margin-left: 35px;
        }
      }
    }
    .bottom {
      display: flex;
      flex-direction: column;
      width: 100%;
      .renew {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 47.98px;
        align-self: flex-end;
        width: 180px;
        background: #de1e35;
        font-family: Abolition;
        font-weight: normal;
        font-size: 20px;
        line-height: 24px;
        letter-spacing: normal;
        color: #ffffff;
        text-transform: uppercase;
        text-decoration: none;
        margin-right: 20px;
      }
      .terms {
        align-self: center;
        font-family: DINPro;
        font-weight: 500;
        font-size: 12px;
        line-height: 24px;
        letter-spacing: normal;
        color: #cccccc;
        margin: 45px 0 25px 0;
      }
    }
  }
  .player {
    width: calc(100% - 18px);
    max-height: calc(100vh - 84px);
    object-fit: contain;
  }
}
</style>